import { render, staticRenderFns } from "./HomeNew_new.vue?vue&type=template&id=c87a4996&scoped=true"
import script from "./HomeNew_new.vue?vue&type=script&lang=js"
export * from "./HomeNew_new.vue?vue&type=script&lang=js"
import style0 from "./HomeNew_new.vue?vue&type=style&index=0&id=c87a4996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a4996",
  null
  
)

export default component.exports